import classNames from 'classnames'

import { commonIcons } from '@apps-common/config/icons'
import { toastSuccess, toastWarning } from '@apps-common/lib/toast'

interface IProps {
  value?: string
  noValue?: string
  textValue?: string
  className?: string
  iconClassName?: string
  showValue?: boolean
  stopPropagation?: boolean
}

export const ButtonCopy: React.FC<IProps> = ({
  value,
  noValue,
  textValue,
  className,
  iconClassName = false,
  showValue,
  stopPropagation = true
}) => {
  const CopyIcon = commonIcons.copy

  if (!value && !noValue && !showValue) return null

  return (
    <>
      {showValue && !value && noValue && (
        <div className={classNames(className, 'text-[1.05em] ml-[4px] text-ellipsis whitespace-nowrap overflow-hidden')}>{noValue}</div>
      )}

      {!!value && (
        <button
          type='button'
          aria-label='Copy text'
          disabled={!value}
          className={classNames(className, 'flex items-center justify-start gap-[2px] text-[1.05em] ml-[4px] hover:opacity-70')}
          onClick={(e) => {
            if (stopPropagation) {
              e.stopPropagation()
            }
            if (!window.isSecureContext) {
              toastWarning(`Clipboard disabled on in-secure connections!`)

              return
            }
            toastSuccess(`Copied to clipboard!`)
            navigator.clipboard.writeText(value || '')
          }}
        >
          {textValue && <div className='text-ellipsis whitespace-nowrap overflow-hidden'>{textValue}</div>}
          {showValue && value && <div className='text-ellipsis whitespace-nowrap overflow-hidden'>{value}</div>}
          <CopyIcon className={classNames(iconClassName, 'relative')} />
        </button>
      )}
    </>
  )
}
